import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=35bd59af&scoped=true&lang=html"
import script from "./main-sidebar.vue?vue&type=script&lang=js"
export * from "./main-sidebar.vue?vue&type=script&lang=js"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=35bd59af&prod&lang=css"
import style1 from "./main-sidebar.vue?vue&type=style&index=1&id=35bd59af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd59af",
  null
  
)

export default component.exports